<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Manage Special Price PDF</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <div class="w-full overflow-x-auto">
      <app-data-table
        class="block min-w-[32rem]"
        [tableHeaders]="MainHeaders"
        [tableEntries]="MainEntries"
        (save)="openFile($event)"
        [pagination]="false"
      ></app-data-table>
    </div>
    <div class="mt-8 flex flex-col gap-8 lg:flex-row">
      <div class="flex w-full flex-col gap-4 lg:w-1/4 lg:max-w-72">
        <h2 class="sub-heading">Select Files</h2>
        <input
          type="file"
          name=""
          id=""
          (change)="onFileChange($event)"
          accept=".gif, .png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx, .txt"
          multiple
        />
        <div class="reminder-div">
          <h3 class="mb-4 text-lg">Reminder!</h3>
          <p class="text-sm">
            Kindly upload in the following format: gif, png, jpg,
            jpeg, pdf, doc, docx, xls, xlsx, txt.
          </p>
        </div>
      </div>
      <div class="flex min-w-0 flex-1 flex-col gap-4">
        <h2 class="sub-heading">Upload queue</h2>
        <p>Queue length: {{ SecondaryEntries.length }}</p>
        <div class="w-full overflow-x-auto">
          <table class="w-full min-w-[52rem] text-sm">
            <thead>
              <tr>
                <th
                  *ngFor="
                    let header of SecondaryHeaders;
                    let index = index
                  "
                  [ngClass]="{ 'w-5/12': index == 0 }"
                  class="bg-primary p-2 font-bold text-white"
                >
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody class="secondary-table text-sm">
              <tr *ngFor="let entry of SecondaryEntries">
                <td class="font-bold">
                  {{ entry.Name }}
                </td>
                <td>
                  {{ entry.Size }}
                </td>
                <td>
                  <div class="progress-bar-container">
                    <div
                      class="progress-bar"
                      [style.width.%]="entry.Progress * 100"
                    ></div>
                  </div>
                </td>
                <td class="text-center">
                  <fa-icon
                    *ngIf="entry.Status === 'success'"
                    [icon]="faCheck"
                  ></fa-icon>
                  <fa-icon
                    *ngIf="
                      entry.Status === 'error' ||
                      entry.Status === 'cancelled'
                    "
                    [icon]="faXmark"
                  ></fa-icon>
                </td>
                <td class="flex min-w-64 gap-1">
                  <button
                    class="file-btn shorter-btn add-btn"
                    [disabled]="
                      entry.Status === 'uploading' ||
                      entry.Status === 'success'
                    "
                    (click)="uploadEntries(entry.Name)"
                  >
                    <fa-icon
                      [icon]="faUpload"
                      class="mr-1"
                    ></fa-icon
                    >Upload
                  </button>
                  <button
                    class="file-btn shorter-btn clear-btn"
                    [disabled]="entry.Status !== 'uploading'"
                    (click)="cancelUpload(entry.Name)"
                  >
                    <fa-icon
                      [icon]="faCancel"
                      class="mr-1"
                    ></fa-icon
                    >Cancel
                  </button>
                  <button
                    class="file-btn shorter-btn delete-btn"
                    (click)="removeEntry(entry.Name)"
                  >
                    <fa-icon
                      [icon]="faTrash"
                      class="mr-1"
                    ></fa-icon
                    >Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>Queue progress:</p>
        <div class="progress-bar-container">
          <div
            class="progress-bar"
            [style.width.%]="totalProgress * 100"
          ></div>
        </div>
        <div class="flex w-full flex-col gap-1 md:w-fit md:flex-row">
          <button
            class="shorter-btn add-btn"
            [disabled]="isUploadDisabled()"
            (click)="uploadEntries()"
          >
            <fa-icon [icon]="faUpload" class="mr-1"></fa-icon>Upload
            All
          </button>
          <button
            class="shorter-btn clear-btn"
            [disabled]="isCancelDisabled()"
            (click)="cancelUpload()"
          >
            <fa-icon [icon]="faCancel" class="mr-1"></fa-icon>Cancel
            All
          </button>
          <button
            class="shorter-btn delete-btn"
            [disabled]="SecondaryEntries.length == 0"
            (click)="removeEntry()"
          >
            <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>Remove
            All
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
